/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import { Search } from "lucide-react";

export default function StockHero() {

    return (

        <section className="pb-16 pt-4">

            <div className="max-w-7xl mx-auto px-6 lg:px-10">

                <div className="max-w-4xl">

                    <div
                        className="
                            text-sm
                            uppercase
                            tracking-[0.3em]
                            text-emerald-400
                            mb-5
                        "
                    >
                        ORION ANALYTICS
                    </div>

                    <h1
                        className="
                            text-5xl
                            lg:text-7xl
                            font-bold
                            text-white
                            leading-tight
                            mb-6
                        "
                    >
                        Stock Intelligence
                    </h1>

                    <p
                        className="
                            text-slate-300
                            text-xl
                            max-w-3xl
                            mb-10
                        "
                    >
                        Discover opportunities through momentum,
                        volatility, market breadth, volume analytics,
                        sector rotation and institutional-grade
                        market intelligence.
                    </p>

                    {/*<div className="relative max-w-xl">*/}

                    {/*    <Search*/}
                    {/*        size={18}*/}
                    {/*        className="*/}
                    {/*            absolute*/}
                    {/*            left-4*/}
                    {/*            top-4*/}
                    {/*            text-slate-400*/}
                    {/*        "*/}
                    {/*    />*/}

                    {/*    <input*/}
                    {/*        type="text"*/}
                    {/*        placeholder="Search stocks..."*/}
                    {/*        className="*/}
                    {/*            w-full*/}
                    {/*            rounded-xl*/}
                    {/*            bg-slate-800/70*/}
                    {/*            border*/}
                    {/*            border-slate-700*/}
                    {/*            py-3*/}
                    {/*            pl-12*/}
                    {/*            pr-4*/}
                    {/*            text-white*/}
                    {/*            placeholder-slate-400*/}
                    {/*            focus:outline-none*/}
                    {/*            focus:border-emerald-500*/}
                    {/*        "*/}
                    {/*    />*/}

                    {/*</div>*/}

                </div>

            </div>

        </section>

    );
}